import { GameServiceEvent } from "@netent/origin";
import { DisplayMode, IPlayUIState } from "@netent/playui";
import { ListenerCreator } from "../../types";

const setDisplayMode = () => (mode: string): IPlayUIState => {
  let displayMode;
  switch (mode) {
    case "TOPBAR": {
      displayMode = DisplayMode.TOPBAR;
      break;
    }
    case "MINIMAL": {
      displayMode = DisplayMode.MINIMAL;
      break;
    }
    default: {
      displayMode = DisplayMode.DEFAULT;
    }
  }
  return {
    displayMode
  };
};

const showHomeButton = () => (): IPlayUIState => ({
  home: {
    enabled: true
  }
});

const hideHomeButton = () => (): IPlayUIState => ({
  home: null
});

const blocked = () => (): IPlayUIState => ({
  uiBlocker: {
    enabled: true
  }
});

const released = () => (): IPlayUIState => ({
  uiBlocker: {
    enabled: false
  }
});

export const listeners = new Map<GameServiceEvent, ListenerCreator>([
  ["showHomeButton", showHomeButton],
  ["hideHomeButton", hideHomeButton],
  ["setDisplayMode", setDisplayMode],
  ["blocked", blocked],
  ["released", released]
]);
